<template>
  <a-drawer
    :title="title"
    :visible="open"
    width="720"
    @close="onClose"
  >
    <a-spin :spinning="loading">
      <a-empty v-if="!loading && !list.length" description="该用户暂未绑定银行卡" />
      <a-table
        v-else
        rowKey="id"
        size="small"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="isDefault" slot-scope="text">
          <a-tag v-if="text === 1" color="blue">默认</a-tag>
          <span v-else>—</span>
        </span>
        <span slot="createTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
      </a-table>
    </a-spin>
  </a-drawer>
</template>

<script>
import { listUserBankCards } from '@/api/biz/user'

export default {
  name: 'UserBankCardManage',
  data() {
    return {
      open: false,
      loading: false,
      title: '银行卡管理',
      list: [],
      columns: [
        { title: '银行名称', dataIndex: 'bankName', width: 140 },
        { title: '开户名', dataIndex: 'accountName', width: 120 },
        { title: '卡号', dataIndex: 'cardNo', width: 180 },
        { title: '默认卡', dataIndex: 'isDefault', scopedSlots: { customRender: 'isDefault' }, width: 90 },
        { title: '绑定时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 170 }
      ]
    }
  },
  methods: {
    onClose() {
      this.open = false
      this.list = []
    },
    handleOpen(record) {
      const name = record.nickname || record.email || record.id
      this.title = `银行卡管理 - ${name}`
      this.open = true
      this.loading = true
      this.list = []
      listUserBankCards(record.id).then(res => {
        this.list = res.data || []
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
